import { LookupOfSystemInt32 } from '../../generated/auth/models/Sasfin/Wealth/Online/BL/Models/lookup-of-system-int-32';

export interface IAssetManagersState {
  list: LookupOfSystemInt32[];
  isLoading: boolean;
}

export const initialUIState: IAssetManagersState = {
  list: [],
  isLoading: false,
};
